module.exports = __webpack_public_path__ + "static/img/certificate-5.1456880.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/certificate-5.png
// module id = 6jj3
// module chunks = 1